import { useState } from 'react';

import { useRouter } from 'next/router';

import { SeoHead } from '@components/SeoHead';
import SearchBase from '@components/base/SearchBase';
import { References } from '@components/views';

import { StateProvider } from '@appbaseio/reactivesearch';
import { referencesIndex } from '@config/reactive-search';
import { ReferencesFilters } from '@constants/filters';
import { PageLayout } from '@layout';
import { Paper, useMediaQuery, useTheme } from '@mui/material';

import { checkFiltersSelected } from 'shared/methods';

interface ReferencesProps {
    filters: {
        [key in ReferencesFilters]?: string[];
    };
}

const ReferencesPage = ({ filters }: ReferencesProps) => {
    const [hasSelectedFilters, setHasSelectedFilters] = useState(false);
    const router = useRouter();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            <SeoHead />
            <PageLayout>
                <Paper
                    elevation={0}
                    variant={isMobile ? 'elevation' : 'outlined'}
                    sx={{
                        padding: { xs: '10px', md: '20px' },
                        borderRadius: '10px',
                    }}
                >
                    <SearchBase
                        app={referencesIndex}
                        setSearchParams={(newURL) => {
                            router.push(newURL);
                        }}
                    >
                        <References
                            filters={filters}
                            hasSelectedFilters={hasSelectedFilters}
                        />
                        <StateProvider
                            //Counts coming from filter bucket list size
                            onChange={(state, nextState) => {
                                checkFiltersSelected(
                                    { ...state, ...nextState },
                                    hasSelectedFilters,
                                    setHasSelectedFilters,
                                    'ref_',
                                );
                            }}
                        />
                    </SearchBase>
                </Paper>
            </PageLayout>
        </>
    );
};

export default ReferencesPage;
